import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
/**
 * `fileSize` is what the API sizes the signing window from. S3 checks the
 * signature against the time the body lands rather than the time the request
 * starts, so a slow upload of a large file outlives a window sized for a photo
 * and comes back 403 "Request has expired". Omitting it is safe — the API
 * falls back to the old two minutes — but a video sent without it will keep
 * failing on a site connection.
 */
export const getProjectBankImagesUploadSignedUrl = async ({
  projectId,
  fileName,
  contentType,
  fileSize,
}) => {
  let apiPath = `files/upload-signed-url/project-bank/${projectId}/images`;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    // aws4 looks for body; axios for data. They must stay identical or the
    // signature will not match what is sent.
    body: JSON.stringify({ fileName, contentType, fileSize }),
    data: { fileName, contentType, fileSize },
  };

  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
